import {} from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../shared/component-base';
import { openCookiesDialog } from '../../shared/components/cookie-manager/cookie-manager.component';
import packageInfo from '../../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  readonly translate = inject(TranslateService);

  public lang: string;
  public isOnApp = false;
  public version: string = packageInfo.version;

  constructor(private ref: ChangeDetectorRef) {
    super();

    this.lang = this.translate.currentLang;

    this.restApiService.getFiles().subscribe({
      next: files => {
        files.forEach(f => {
          const key = f.key.slice(0, -3);
          if (key in this.staticFiles) {
            const lang = f.key.split('_').pop();
            if (lang) {
              this.staticFiles[key].files[lang] = f.file?.id || null;
            } else {
              console.error('bad lang for this key', f);
            }
          } else {
            console.error('key in not in the list', key, this.staticFiles);
          }
        });
        this.ref.detectChanges();
      },
    });

    if (this.nativeAppService.isNativePlatform()) {
      this.isOnApp = true;
    }
  }

  public staticFiles: {
    [key in string]: {
      name: string;
      files: { [lang in string]: number | null };
    };
  } = {
    aszf: {
      name: 'ÁSZF',
      files: {},
    },
    aviation: {
      name: 'Repülőtársaságok',
      files: {},
    },
    gdpr: {
      name: 'GDPR',
      files: {},
    },
    cookies: {
      name: 'Cookie szabályzat',
      files: {},
    },
    tos: {
      name: 'Oldalhasználati feltételek',
      files: {},
    },
    travel_rules: {
      name: "Beutazási szabályok'",
      files: {},
    },
  };

  public openCookies() {
    openCookiesDialog.next();
  }
}
